import React, { Component } from 'react';
import AiOption from "./AiOption";
import AiInputWrap from "./AiInputWrap";
import AiInputWrapDia from "./AiInputWrapDia";
import AiReviewWrap from './AiReviewWrap';
import { SPECIAL_NOTE_SMALL } from '../constants';
import { SPECIAL_NOTE_SMALL1 } from '../constants';
import { SPECIAL_NOTE_SMALL2 } from '../constants';
import { SPECIAL_NOTE_LINK } from '../constants';

//import {Accordion} from 'primereact/components/accordion/Accordion';
//import {AccordionTab} from 'primereact/components/accordion/Accordion';


class AiOptionSet extends Component {
  
//test
  render() {
    //console.log('get all options',this.props.options);
    var rows = [];
    //var bandrows = [];
    var last =0 
    var cur_option
    if (this.props.options['options_all'] !== undefined) {
      last = this.props.options['options_all'].length -1
    }  
    for (let i in this.props.options['options_all']) {
      cur_option= this.props.options['options_all'][i]
      //console.log('last value',cur_option,parseInt(i,10),last, this.props.single_sc_option)
      var lastValue ='false'
      if (parseInt(i,10)===last || (cur_option === "sc" && this.props.single_sc_option )) {
        lastValue = 'true' 
        //console.log('let lastValue be TRUE')
      } 

      var cur_details= this.props.options['options_' + cur_option]
      //console.log('cur_option',cur_option,this.props.options)
      var cur_name = cur_details.name
      if (cur_details.option_name === 'stone') {
        cur_name = "Stone"
        
      }
      var cur_value = this.props.options['value_' + cur_option]
      var band_attrs=["ben","bmet","bmetc"]
      
      var red_note =SPECIAL_NOTE_SMALL
      //var red_note ='' 
      //var red_note =SPECIAL_NOTE_SMALL
      var red_note1=''
      var red_note2=''
      var red_link=''
      //console.log('SITES',this.props.site)
      /*if (this.props.site === 'kay'){
        red_note1 =SPECIAL_NOTE_SMALL1
        red_note2 =SPECIAL_NOTE_SMALL2
        red_link =<a href={SPECIAL_NOTE_LINK}>click here</a> 
      }*/
      var option_name =
       this.props.options['options_' + cur_option].option_name !== undefined ? ' ai-name-'+this.props.options['options_' + cur_option].option_name: ''
    //  console.log('this.props.option_name',option_name,this.props,cur_details)
    var maxSliderSize = (this.props.optionNumber * this.props.optionSize + 60) +'px';
    var maxSliderSizeNum = this.props.optionNumber * this.props.optionSize 
      if (cur_details.show)
       switch (cur_details.type) {
      
        case 'select':
        case 'control':
          //console.log('AIOptions',this.props)

          if (band_attrs.indexOf(cur_option) === -1) 
           rows.push(<AiOption 
            key={cur_option} 
            name={cur_name} 
            attr={cur_option} 
            css={cur_details.css}
            ds ={this.props.ds}
            dctw ={this.props.dctw}
            head ={this.props.head}
            bandC ={this.props.bandC}
            bandS ={this.props.bandS}
            sh ={this.props.sh}
            children={cur_details.options} 
            optionNumber={this.props.optionNumber} 
            optionSize={this.props.optionSize}
            optionName={option_name}
            initialValue={cur_value}
            image_base={cur_details.image_base}
            image_postfix={cur_details.image_postfix}
            last= {lastValue}
            options_all={this.props.options_all}
            />);
           else
            rows.push(<AiOption 
              key={cur_option} 
              name={cur_name} 
              attr={cur_option} 
              css={cur_details.css}
              ds ={this.props.ds}
              dctw ={this.props.dctw}
              head ={this.props.head}
              sh ={this.props.sh}
              children={cur_details.options} 
              optionNumber={this.props.optionNumber} 
              optionSize={this.props.optionSize}
              optionName={option_name}
              initialValue={cur_value}
              image_base={cur_details.image_base}
              image_postfix={cur_details.image_postfix}
              last= {lastValue}
              options_all={this.props.options_all}
              />);
              break;
        case 'inputDia':
              if (band_attrs.indexOf(cur_option) === -1) 
                rows.push(<AiInputWrapDia
                  key={cur_option} 
                  name={cur_details.name} 
                  children={cur_details.options} 
                  
                  />);
                  break;

        case 'input':
        if (band_attrs.indexOf(cur_option) === -1) 
          rows.push(<AiInputWrap 
            key={cur_option} 
            name={cur_details.name} 
            product='ring'
            maxSliderSize ={maxSliderSizeNum}
            children={cur_details.options} 
            options_all={this.props.options_all}
           
            
        //    optionNumber={this.props.optionNumber} 
        //    optionSize={this.props.optionSize}
            />);
            else
            rows.push(<AiInputWrap 
                key={cur_option} 
                name={cur_details.name} 
                maxSliderSize ={maxSliderSizeNum}
                product='band'
                children={cur_details.options} 
                options_all={this.props.options_all}
                />);
               
            break;
        default:
            break;
        
      }
      
    }
   // console.log('rows options',this.props)
   var addchat=''
   //<!--div key="patent1" className="separator2"><p>
   //{addchat}  </p></div-->
   //      if (h>w)
             addchat= 
             <div className="ai-chat-block">
             <div className="ai-chat-icon">
                                    <img alt='chat' width='45px' height='45px' src="//static.thepersonalizedbest.com/pers4/chat.jpg"></img>
             </div>
             <div className="ai-chat-text">
                            <p>Have a question about {this.props.title}?</p>
                            <p><a href="javascript:document.getElementsByClassName('LPMcontainer')[0].click();" >Chat Now</a></p>
             </div>
             </div> 
    return (
      <div className='ai-option-wrap' style={{width:maxSliderSize}}>
      {rows}
     
      <AiReviewWrap/>
      <div className='ai-special-note'><font color='red'>{red_note}{red_note1}{red_link}{red_note2}</font></div><p></p>
            
    {addchat} <p/>  
      {/*<div className='ai-bottom'/>*/}
      </div>
    );
  }
}
export default AiOptionSet;


// WEBPACK FOOTER //
// ./src/layout/AiOptionSet.js